import {Container} from "@mui/material";

const Footer = ()=>{

    return (
        <footer style={{background:`var(--deep-blue)`, color:`#fff`, padding:`8px 0`, textAlign: `center`}}>
            <Container>
                <small style={{fontSize: `14px`}}>
                (C) セブ日本人会
                </small>
            </Container>
        </footer>
    )
}
export default Footer;
